import React from 'react';
import { HoverCard, HoverCardContent, HoverCardTrigger } from './ui/hover-card';

export interface VehiclePlateHoverProps {
  plate?: string | null;
  brand?: string | null;
  model?: string | null;
  year?: number | string | null;
  engine?: string | null;
  color?: string | null;
  fuel?: string | null;
  mileage?: number | string | null;
  vin?: string | null;
  className?: string;
}

/**
 * Patente con la ficha del vehículo al pasar el mouse: marca y modelo, año,
 * motor, combustible, color, km y VIN. Para listas donde solo entra la
 * patente (Turnos, Taller). Si no hay más datos que la patente, muestra el
 * texto pelado sin hover.
 */
export default function VehiclePlateHover({ plate, brand, model, year, engine, color, fuel, mileage, vin, className }: VehiclePlateHoverProps) {
  if (!plate) return <span className={className}>-</span>;
  const nombre = [brand, model].filter(Boolean).join(' ');
  const filas: Array<[string, string]> = [];
  if (year) filas.push(['Año', String(year)]);
  if (engine) filas.push(['Motor', String(engine)]);
  if (fuel) filas.push(['Combustible', String(fuel)]);
  if (color) filas.push(['Color', String(color)]);
  const km = Number(mileage);
  if (km > 0) filas.push(['Km', new Intl.NumberFormat('es-AR').format(km)]);
  if (vin) filas.push(['VIN', String(vin)]);
  if (!nombre && filas.length === 0) return <span className={className}>{plate}</span>;

  return (
    <HoverCard openDelay={150} closeDelay={80}>
      <HoverCardTrigger asChild>
        <span className={`cursor-help underline decoration-dotted decoration-muted-foreground/60 underline-offset-4 ${className || ''}`}>
          {plate}
        </span>
      </HoverCardTrigger>
      <HoverCardContent align="start" className="w-64 p-3">
        <div className="font-mono text-sm font-semibold text-foreground">{plate}</div>
        {nombre && <div className="text-sm text-foreground">{nombre}</div>}
        {filas.length > 0 && (
          <dl className="mt-2 grid grid-cols-[auto_1fr] gap-x-3 gap-y-0.5 text-xs">
            {filas.map(([k, v]) => (
              <React.Fragment key={k}>
                <dt className="text-muted-foreground">{k}</dt>
                <dd className="truncate text-foreground">{v}</dd>
              </React.Fragment>
            ))}
          </dl>
        )}
      </HoverCardContent>
    </HoverCard>
  );
}
